import httpClient from '@api/httpClient'
import { Order } from '@models/order'
import type { Stop } from '@models/stop'
import { stopsUrls } from './constants'

const getStopOrders = async (stopId: number) => {
  const { data } = await httpClient.get<Order[]>(stopsUrls.stopOrders(stopId))
  return data
}

const getStop = async (id: number) => {
  const { data } = await httpClient.get<Stop>(stopsUrls.stop(id))
  return data
}

export default {
  getStopOrders,
  getStop,
}
